import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { PrismCodeComponent } from 'src/app/shared/components/prism-code/prism-code.component';
import { CoreApisService } from '../core-apis.service';
import { CommonModule, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-robust-core-apis',
  templateUrl: './robust-core-apis.component.html',
  styleUrls: ['./robust-core-apis.component.scss'],
  imports: [CommonModule, PrismCodeComponent],
})
export class RobustCoreApisComponent implements OnInit, OnDestroy {
  @ViewChild(PrismCodeComponent) prismCodeComponent!: PrismCodeComponent;

  subscriptions: Subscription[];
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private coreApiPageService: CoreApisService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  coreApiDesignData: any;
  collectData: any;
  convertData: any;
  payData: any;
  holdData: any;
  automateData: any;
  connectData: any;
  active = 'collectData-0';
  clicked = false;

  showCustomPlanModal = false;

  apiType: 'payment' | 'fx' | 'pbl' | 'treasury' | 'multiCurrencyAccounts' | 'multiCurrencyWallets' = 'payment';
  apiModalTitle = 'Payments API';

  activeTabIndex = 0;
  activeDataCardIndex = 0;

  ngOnInit(): void {
    this.getCoreAPIs();
  }

  getCoreAPIs() {
    this.coreApiPageService.api$.subscribe(data => {
      if (data !== null) {
        this.coreApiDesignData = data;
        this.coreApiDesignData.component1[0].active = true;
      }
    });
  }

  switchTab(index: number) {
    this.activeTabIndex = index;
    this.activeDataCardIndex = 0;

    if (this.activeTabIndex === 0) {
      this.apiType = 'payment';
    } else if (this.activeTabIndex === 1) {
      this.apiType = 'fx';
    } else if (this.activeTabIndex === 2) {
      this.apiType = 'pbl';
    }
    this.prismCodeComponent.apiType = this.apiType;
    this.prismCodeComponent.updateContent();
  }

  onMouseOverConvert(index: any, type: string) {
    this.activeDataCardIndex = index;
    type = type.trim();
    if (type === 'FX API') this.apiType = 'fx';
    else if (type === 'Payments Links API') {
      this.apiType = 'pbl';
    } else if (type === 'Payments APIs') {
      this.apiType = 'payment';
    } else if (type === 'Multi-Currency Wallets API') {
      this.apiType = 'multiCurrencyWallets';
    } else if (type === 'Multi-Currency Accounts API') {
      this.apiType = 'multiCurrencyAccounts';
    } else if (type === 'Treasury API') {
      this.apiType = 'treasury';
    }

    if (
      this.prismCodeComponent &&
      this.prismCodeComponent.apiType !== this.apiType
    ) {
      this.prismCodeComponent.apiType = this.apiType;
      this.prismCodeComponent.updateContent();
    }
  }

  openCodeSnippetModal(type: string) {
    this.showCustomPlanModal = true;

    this.apiModalTitle = type;

    // disable body scroll
    this.document.body.style.overflow = 'hidden';
  }

  closeCodeSnippetModal() {
    this.showCustomPlanModal = false;
    this.document.body.style.overflow = 'auto';
  }
}
